import css from './news-block.module.scss';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { NEWS } from 'src/constants/routes';
import { NewsListItem } from 'src/pages/news/interfaces';
import { renderDate } from 'src/utils/date-time';
import classNames from 'classnames';
import { useGetNews } from '../data/queries';
import { ReactComponent as EventLinkIcon } from 'src/assets/event-arrow.svg';

export default function NewsBlock() {
  const myRef = useRef<[] | HTMLDivElement[]>([]);
  const NEWS_SCROLL_TIMEOUT = 5 * 1000;

  const containerRef = useRef<HTMLDivElement>(null);
  const { data: news = [] } = useGetNews();
  const [index, setIndex] = useState(0);
  const [selected, setSelected] = useState(news[index]);

  const scroll = useCallback((idx: number) => {
    const el = containerRef.current?.getBoundingClientRect();
    const isVisible =
      el &&
      el.top >= -100 &&
      el.left >= 0 &&
      el.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      el.right <= (window.innerWidth || document.documentElement.clientWidth);

    isVisible && myRef.current[idx]?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, []);

  useEffect(() => {
    news.length > 1 && setSelected(news[index]);
    const timeoutId = setTimeout(() => {
      const newI = index === news.length - 1 ? 0 : index + 1;
      scroll(newI);
      setIndex(newI);
    }, NEWS_SCROLL_TIMEOUT);
    return () => clearTimeout(timeoutId);
  }, [NEWS_SCROLL_TIMEOUT, index, news, scroll]);

  return (
    news && (
      <div className={css.newsBlock}>
        <div className={css.container}>
          <div className={css.images}>
            {selected && (
              <>
                <div className={css.imageBackground}>
                  <img src={selected?.imgUrl} alt={selected?.title} />
                </div>
                <img src={selected?.imgUrl} alt={selected?.title} />
              </>
            )}
            <Link to={`${NEWS.relativePath}/${selected?.slug}`} className={css.info}>
              <p className={css.time}>{selected && renderDate(selected?.publishedAt)}</p>
              <p className={css.title}>{selected?.title}</p>
            </Link>
          </div>
          <div className={css.news}>
            <Link to={NEWS.relativePath}>
              <p>Усі новини</p> <EventLinkIcon />
            </Link>
            <div className={css.titles} ref={containerRef}>
              {news.map((item: NewsListItem, i: number) => (
                <div
                  key={item.id}
                  ref={(el: HTMLDivElement) => (myRef.current[i] = el)}
                  className={classNames(css.newsItem, selected?.id === item.id ? css.active : '')}
                  onClick={() => setSelected(item)}>
                  <p className={css.title}>{item.title}</p>
                  <p className={css.time}>{renderDate(item.publishedAt)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  );
}
